import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BASE = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach session_token from localStorage fallback (for testing agent Bearer)
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem("session_token");
    if (t) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${t}`;
    }
  } catch (_) { /* noop */ }
  return config;
});

export function imageProxyUrl(url) {
  const t = (typeof window !== "undefined" && localStorage.getItem("session_token")) || "";
  const q = new URLSearchParams({ url });
  if (t) q.set("auth", t);
  return `${API}/image-proxy?${q.toString()}`;
}

export function fileUrl(fileId) {
  const t = (typeof window !== "undefined" && localStorage.getItem("session_token")) || "";
  const q = new URLSearchParams();
  if (t) q.set("auth", t);
  const s = q.toString();
  return `${API}/files/${fileId}${s ? "?" + s : ""}`;
}
